import { Grid, Typography, Button } from "@mui/material";
import ConfirmationQuote from "../components/confirmation/ConfirmationQuote";
import CustomerFeedback from "../components/feedback/CustomerFeedback";
import { useSelector } from "react-redux";
import NewConfirmation from "../components/professionalConfirmation/NewConfirmation";
import { useLocation, useNavigate } from "react-router-dom";

const CustomerQuotationScreen = () => {
  const { user, userProfile } = useSelector((state: any) => state?.user);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    const redirectToCustomerOtp = location.search
      ? `/customer${location.search}`
      : "/customer";

    localStorage.clear();
    sessionStorage.clear();
    navigate(redirectToCustomerOtp);
  };


  return (
    <>
      <Grid
        container
        justifyContent={"center"}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        sx={{
          background: "#f4f4f4",
          paddingTop: "16px",
          paddingBottom: "16px",
          minHeight: "auto !important",
        }}
      >
        <Grid
          item
          xs={12}
          md={12}
          // justifyContent={"center"}
          sx={{
            background:
              userProfile?.is_feedback_submitted ||
              userProfile?.is_asked_for_feedback
                ? "#E5F4F1"
                : "#f4f4f4",
            padding: "0px 16px",
            paddingBottom: "16px",
            minHeight: "auto !important",
          }}
        >
          {userProfile?.is_feedback_submitted ||
          userProfile?.is_asked_for_feedback ? (
            <Typography
              variant="h3"
              align="center"
              sx={{ fontWeight: 600, marginBottom: 3 }}
            >
              Customer Feedback
            </Typography>
          ) : (
            <Grid
              container
              sx={{
                background: "#fff",
                borderRadius: "8px",
                padding: "20px 24px",
                marginBottom: "24px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                alignItems: "center",
              }}
            >
              <Grid item xs={12} md={10}>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    fontSize: "28px",
                    color: "#1d997d",
                    marginBottom: "8px",
                  }}
                >
                  Customer Portal
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "14px",
                    color: "#637381",
                    lineHeight: 1.6,
                  }}
                >
                  Manage your removal process, view quotes, and track your
                  survey status
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={2}
                sx={{
                  textAlign: { xs: "left", md: "right" },
                  marginTop: { xs: "16px", md: 0 },
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleLogout}
                  sx={{
                    color: "#1d997d",
                    borderColor: "#1d997d",
                    textTransform: "none",
                    fontSize: "14px",
                    fontWeight: 600,
                    padding: "8px 24px",
                    "&:hover": {
                      borderColor: "#1d997d",
                      backgroundColor: "rgba(29, 153, 125, 0.04)",
                    },
                  }}
                >
                  Logout
                </Button>
              </Grid>
            </Grid>
          )}
          {userProfile?.is_feedback_submitted ||
          userProfile?.is_asked_for_feedback ? (
            <CustomerFeedback />
          ) : (
            <>
              {user?.user?.is_professional_plan ? (
                <NewConfirmation />
              ) : (
                <ConfirmationQuote />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};
export default CustomerQuotationScreen;
